import React from "react";
import { SectionWrapper } from "../UI/SectionWrapper/SectionWrapper";
import { CMSAsset } from "../../models/CMS/cmsAsset";
import { Asset } from "../../models/asset";
import "./CarouselPreview.scss";
import { useSelector } from "react-redux";
import { AppState } from "@client/types/redux";

interface ICarouselPreviewProps {
  assets: Array<any>;
}

export const CarouselPreview: React.FC<ICarouselPreviewProps> = ({
  assets,
}) => {
  const settings = useSelector((state: AppState) => state.config);
  const showTransformationGUI = settings?.showTransformationGui;
  // Helper to get image/title depending on asset type
  function getImage(asset: Asset | CMSAsset) {
    if (showTransformationGUI) {
      return (asset as CMSAsset).getImage();
    }
    return (asset as Asset).getImage();
  }

  function getTitle(asset: Asset | CMSAsset) {
    if (showTransformationGUI) {
      return (asset as CMSAsset).getTitle();
    }
    return (asset as Asset).getTitle();
  }

  return (
    <SectionWrapper>
      <h4>
        Carousel Preview{" "}
        <span className="description">
          Please note that this isn't an exact implementation visualization nor
          all the assets might not be available at all the hotels.
        </span>
      </h4>
      <div className="d-flex asset-slide-wrapper">
        {assets.map((asset) => (
          <div
            className="asset-slide"
            style={{
              backgroundImage: `url(${getImage(asset)})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
            key={asset.assetId}
          >
            <span className="text-white">{getTitle(asset)}</span>
          </div>
        ))}
      </div>
    </SectionWrapper>
  );
};
